<template>    
    <span :class="hot_text_class" class="hot-text-container">             
        <b-btn variant="primary" class="btn-sm ht-edit-button">
                <span class="edit-button-span" ><font-awesome-icon @click.prevent="edit" :icon="['far', 'edit']" /></span>
        </b-btn>
        <span class="ht-text-span">{{ selected_text }}</span> 
        <edit-hot-text-question-modal
            style="position: absolute;"
            v-model="show_edit_hot_text_modal"
            :selected_text="selected_text"
            :correct="correct"
            @save="save"
            @hide="show_edit_hot_text_modal = false"
        />
    </span> 
</template>

<style lang="scss">
    .hot-text-container .ht-edit-button{
        display: none;
    }

    .hot-text-container:hover .ht-edit-button{
        display: inline-block;
    }
    .hot_text_incorrect{
        background-color: pink;
    }

    .hot_text_correct{
        background-color: lightgreen;
    }

</style>

<script>
import EditHotTextQuestionModal from '@/components/modals/tiptap/EditHotTextQuestionModal'

import { read_only } from 'vue'

export default {
    name: 'HotText',
    data: () => ({
        show_edit_hot_text_modal: false,
    }),
    props: ['node', 'updateAttrs', 'view'],
    components: {
        EditHotTextQuestionModal
    },
    computed: {
        hot_text_id: {
            get () {
                return this.node.attrs.hot_text_id
            },
            set (hot_text_id) {
                // we cannot update `hot_text_id` itself because `this.node.attrs` is immutable
                this.updateAttrs({
                    hot_text_id,
                })
            },
        },
        selected_text: {
            get () {
                return this.node.attrs.selected_text
            },
            set (selected_text) {
                this.updateAttrs({
                    selected_text,
                })
            },
        },
        hot_text_class: {
            get () {
                return this.node.attrs.hot_text_class
            },
            set (hot_text_class) {
                this.updateAttrs({
                    hot_text_class,
                })
            },
        },
        correct: {
            get () {
                return this.node.attrs.correct
            },
            set (correct) {
                this.updateAttrs({
                    correct,
                })
            },
        },
        style: {
            get () {
                return this.node.attrs.style
            },
            set (style) {
                this.updateAttrs({
                    style,
                })
            },
        },
    },
    watch: {

    },
    methods: {
        toggleCorrect(){
            if(!this.correct){
                this.updateAttrs({
                    correct: true, // Update the selected_text attribute
                });
                this.updateAttrs({
                    hot_text_class: 'hot_text_correct'
                });
                this.updateAttrs({
                    style: 'background-color: lightgreen'
                });
            }
            else{
                this.updateAttrs({
                    correct: false, // Update the selected_text attribute
                });
                this.updateAttrs({
                    hot_text_class: 'hot_text_incorrect'
                });
                this.updateAttrs({
                    style: 'background-color: pink'
                });
            }
        },
        edit () {
            this.show_edit_hot_text_modal = true;
        },
        save (new_text_value, new_correct_value) {
            //correct
            if(
                (this.correct == null && new_correct_value == true)
                ||
                (this.correct == true && new_correct_value != true) 
                ||
                (this.correct == 'true' && new_correct_value != true) 
                || 
                (this.correct == false && new_correct_value == true) 
                || 
                (this.correct == true && new_correct_value == false)
            ){
                this.toggleCorrect();
            }
            //selected_text
            this.selected_text = new_text_value;
            this.show_edit_hot_text_modal = false;
        }
    },
    mounted () {

    }
}
</script>
